export const server_dev = "http://localhost:5001/todoakrefactor/us-central1/api_pro/v1"; //cambiar pro-dev
export const server_devZero = "http://10.147.20.65:5001/v1"; //cambiar pro-dev
export const server_prod = "https://us-central1-todoakrefactor.cloudfunctions.net/api_pro/v1";
export const server = process.env.REACT_APP_SERVER == "prod" ? server_prod : process.env.REACT_APP_SERVER == "dev" ? server_dev : server_prod;
// export const server = server_dev;
// export const server = server_devZero;
export const services = "/auth/service";
export const user = "/auth";
export const mensajeria = "/mensajeria";
export const web = "/web";

